import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { FeatureCard } from '@/components/molecules/FeatureCard/FeatureCard'
import { FeatureCardProps } from '@/components/molecules/FeatureCard/types'
import * as styles from './styles.module.css'

export function FeaturesTabs({ cards }: { cards: FeatureCardProps[] }) {
  const [selectedCard, setSelectedCard] = useState<number | null>(0)
  const [active, setActive] = useState(false)

  const featureCard = selectedCard !== null && cards[selectedCard]

  useEffect(() => {
    if (selectedCard !== null) {
      const accordionItem = document?.querySelector(`#${kebabCase(cards[selectedCard]?.card_title)}`)
      if (accordionItem && active) {
        accordionItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      }
    }
  }, [selectedCard])

  const handleSelect = (index: number) => {
    setSelectedCard(index)
    setActive(true)
  }

  return (
    <>
      <ul className="tablet:flex pt-16 gap-48 justify-between overflow-x-auto border-b-1 border-b-primary-300 hidden [scrollbar-width:_none]">
        {cards.map((card, index) => (
          <li key={card._uid} className={`desktop-${kebabCase(card.card_id)}`}>
            <button
              id={kebabCase(card.card_title)}
              type="button"
              onClick={() => handleSelect(index)}
              data-active={String(index === selectedCard)}
              title={card.card_title}
              className={clsx('pb-17 px-24 text-nowrap text-bodyL text-text-dark-600', styles.tabButton)}
            >
              {card.card_title}
            </button>
          </li>
        ))}
      </ul>
      {featureCard && <FeatureCard {...featureCard} index={selectedCard} />}
    </>
  )
}
